import React, { useState } from "react";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#26E3BA",
      contrastText: "#ffffff"
    }
  },
  overrides: {
    MuiButtonBase: {
      root: {
        outline: "none !important"
      }
    }
    // Example of alternate, "lighter" styling
    // MuiPickersDay: {
    //   daySelected: {
    //     border: "1px solid #26E3BA",
    //     backgroundColor: "white",
    //     color: "#26E3BA",
    //     "&:hover": {                   // < this is how you do pseudo classes
    //       backgroundColor: "white",
    //     }
    //   }
    // }
  }
});

const DateInput = ({
  className,
  disabled,
  initialValue = new Date(),
  placeholder,
  disableFuture,
  disablePast,
  minDate,
  maxDate,
  disableToolbar = true,
  onError = () => {},
  onChange = () => {}
} = {}) => {
  const [selectedDate, setSelectedDate] = useState(initialValue);

  const handleChange = d => {
    if (d && d.isValid()) onChange(d);
    setSelectedDate(d);
  };

  return (
    <div className={className}>
      <ThemeProvider theme={theme}>
        <KeyboardDatePicker
          value={selectedDate}
          placeholder={placeholder}
          disabled={disabled}
          disableFuture={disableFuture}
          disablePast={disablePast}
          minDate={minDate}
          maxDate={maxDate}
          disableToolbar={disableToolbar}
          format="MM/DD/YYYY"
          onChange={handleChange}
          onError={onError}
        />
      </ThemeProvider>
    </div>
  );
};

export default DateInput;
